import React from 'react'

function PlusSquare ({ className, fill }) {
  return (
    <svg fill={fill} className={className} width="30" height="30" viewBox="0 0 30 30">
      <g transform="translate(-54 -289)">
        <g transform="translate(54 289)">
          <path d="M96,202.668h16.5v1.5H96Zm0,0" transform="translate(-89.25 -188.418)" />
          <path d="M202.668,96h1.5v16.5h-1.5Zm0,0" transform="translate(-188.418 -89.25)" />
          <path d="M27,30H3a3.009,3.009,0,0,1-3-3V3A3.009,3.009,0,0,1,3,0H27a3.009,3.009,0,0,1,3,3V27A3.009,3.009,0,0,1,27,30ZM3,1.5A1.5,1.5,0,0,0,1.5,3V27A1.5,1.5,0,0,0,3,28.5H27A1.5,1.5,0,0,0,28.5,27V3A1.5,1.5,0,0,0,27,1.5Zm0,0" />
        </g>
      </g>
    </svg>
  )
}

PlusSquare.defaultProps = {
  className: 'w-full h-full',
  fill: 'currentColor'
}

export default PlusSquare
